import theme from '../../themes/index.en'; 
const { palette, shape,typography,spacing } = theme;

export const GeneralStyles = {
  dividerStyle : {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
   verticalDividerStyle : {
    height: '100%',
    borderLeft: '1px solid rgba(0, 0, 0, 0.12)'
  },
  iconStyle: { 
    marginRight: '8px',
  },
   formContainerStyle : {
    display: 'flex',
    flexDirection: 'column' as 'column',
    justifyContent: 'center', 
    padding: '1rem',
  },
   headerDivStyle : {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center' 
  },
  addIcon: {
    backgroundColor: palette.primary.main,
    color: palette.common.white,
    marginTop: spacing(3),
    '&:hover': {
      backgroundColor: `${palette.primary.main}`
    },
  },
  deleteIcon: {
    color: palette.error.main,
    marginRight: spacing(1),
    cursor: 'pointer',
    fontSize: 20, 
  },
   boxStyle : {
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center',
    padding: '20px',
    border: `2px solid ${palette.background.default}`,
    borderRadius: shape.borderRadius,
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    background: palette.background.default,
    color: palette.primary.main,
    marginBottom: '2rem'
  },
  
   titleContainer : {
    display: 'flex',
    alignItems: 'center',
  },
  
   title : {
    ...typography.h4,
    color: palette.primary.main, 
  },
   subTitle : {
    ...typography.h5,
    color: palette.action.disabled, 
    marginLeft:'10px'
  },
   codeItemStyle:{
    ...typography.h5,
    color: palette.secondary.main, 
  },
  
   cardStyle : {
    backgroundColor: palette.background.paper,
    padding: '16px',
    marginBottom: '1rem',
  },
  
   gridContainerStyle : {
    marginTop: '1rem'
  },
   searchBoxStyle : {
    marginLeft: '1rem'
  },
  
   submitButtonStyle : {
    marginTop: '24px',
    alignItems: 'center',
    marginBottom: '16px',
    marginLeft: '8px',
    background: palette.primary.main,
    border: `1px solid ${palette.primary.main}`,
    color: palette.text.secondary,
    '&:hover': {
      backgroundColor: palette.primary.main
    }
  },
  clearButtonStyle : {
    marginTop: '24px',
    alignItems: 'center',
    marginBottom: '16px',
    marginLeft: '8px',
    backgroundColor: 'transparent',
    border: `1px solid ${palette.error.main}`,
    color: palette.error.main,
    '&:hover': {
      backgroundColor: palette.action.hover,
    },
  },
  
   searchButtonStyle : {
    marginTop: '24px',
    alignItems: 'center',
    marginBottom: '16px',
    marginLeft: '15px',
    color: palette.primary.main
  },
  stickyCardStyle: {
    position: 'sticky',
    bottom: 0,
    zIndex: 1000,
    padding: '10px 0',
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: palette.background.paper,
  }, 
   submitBackStyle : {
    marginTop: '24px',
    alignItems: 'center',
    marginBottom: '16px',
    background: palette.text.secondary,
    color: palette.primary.main,
    border: `1px solid ${palette.primary.main}`,
    '&:hover': {
      backgroundColor: palette.text.secondary
    }
  },
  
   titleStyle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '1rem'
  },
  
   checkBoxStyle : {
    color: palette.primary.main, 
  }, 

   FormGroupStyle : {
    color: palette.primary.main,
    marginTop: '1.3rem'
  },
   starIyles : {
    color: 'gold',
    marginLeft: '4px', 
  },
  
   groupingStyle : {
    position: 'relative',
    border: `1px solid ${palette.action.disabled}`,
    borderRadius: theme.shape.borderRadius,
    marginBottom: '3rem',
    p: 2, 
    '&::before': {
      content: '" "',
      position: 'absolute',
      top: -14,
      left: 20,
      backgroundColor: 'white',
      padding: '0 10px',
    },
  },
   groupingTitleStyle : {
    position: 'absolute',
    top: -17,
    left: 20,
    backgroundColor: 'white',
    padding: '0 10px',
  }, 
   collapseIyle : {
    backgroundColor: palette.secondary.main,
    color: palette.common.white,
    marginLeft: spacing(2),
    '&:hover': {
      backgroundColor: `${palette.secondary.main}`
    },
  },
   
   parentStyle : {
    display: 'flex',
    justifyContent: 'center',
  }, 
  
};
 